import { render, staticRenderFns } from "./BookIntakeVisitForm.vue?vue&type=template&id=6674642b&"
import script from "./BookIntakeVisitForm.vue?vue&type=script&lang=js&"
export * from "./BookIntakeVisitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports